import {createCookie} from './cookie.js'

(function( $ ) {
  var siteURL = "http://" + top.location.host.toString();

  var $internalLinks = $("a[href^='"+siteURL+"'], a[href^='/'], a[href^='./'], a[href^='../'], a[href!='#']");
  
  $internalLinks.not('a[target="_blank"], a[href^="#"], a[href^="mailto:"], a[href^="tel:"], .venobox, .categories a, .gallery a').click(function(e){
    e.preventDefault();
    var href = $(this).attr('href')
    $('body').animate({opacity: 0}, function(){
      window.location = href;
    });
  });
  
  $('a[href="#"]').click(function(e){
    e.preventDefault()
  });

  $('.menu-item-has-children > a').click(function(e) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(this).closest('nav').hasClass('mobile-menu')) {
      $(this).next().slideToggle('fast');
    }
  });

  $('.menu-button').click(function(){
    $('.menu-container').fadeToggle(350);
    $('.header').toggleClass('dark');
    $('.header').toggleClass('opened');
    $(this).toggleClass('close');
    if (navigator.userAgent.indexOf('Firefox') > -1 || navigator.userAgent.indexOf("Edge") > -1) {
      $('.jumbotron, .main, body > .section, body > .footer, .go-top').toggleClass('blur');
    }
  });

  $(".cookies-close").click(function () {
    createCookie('cookies-accepted', 'yes', 31);
    $(".cookies-regulation").animate({bottom:-350}, 600).fadeOut();
    return false;
  });

  if ($('.gallery a').length > 0) {
    $('.gallery a').simpleLightbox();
  }

  // to top

  $(".go-top").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/links.js